import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Form, Breadcrumb } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import moment from 'moment';
import { GetEnrollUser,handleDownload,ApproveTempUser,GetOTP } from '../../utils/axios/EnrollUserAPI';
import { ConfirmAlert, InforAlert, TimerAlert } from '../../utils/swtAlert';
import { GrokLoading } from "../page-layout/loading/Loading";
import { Decrypt } from '../../utils/Helper';
import { GetOrganization } from '../../utils/axios/CompanyAPI';
import { GetLookUps } from '../../utils/axios/LookUpAPI';
const NewEnrollUser = (props) => {
    const navigate = useNavigate();
    const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
    const [data, setData] = useState();
    const [edit, setEdit] = useState(false);
    const [view, setView] = useState(false);
    const [loading, setLoading] = useState(true);
    const [organizationTypeId, setOrganizationTypeId] = useState('');
    const [organizationTypeList, setOrganizationTypeList] = useState([]);
    const [organizationList, setOrganizationList] = useState([]);
    const [organizationId, setOrganizationId] = useState('');
    const columns = [
        {
            name: "Name",
            width: "230px",
            selector: row => row.DisplayName,
            sortable: true,
            cell: row => row.DisplayName,
        },
        {
            name: "Temporary Organization",
            width: "280px",
            selector: row => row.OrganizationName,
            sortable: true,
            cell: row => row.OrganizationName,
        },
        {
            name: "Approved Organization",
            width: "280px",
            selector: row => row.OrganizationId?.Name ? row.OrganizationId?.Name : "NA",
            sortable: true,
            cell: row => row.OrganizationId?.Name ? row.OrganizationId?.Name : "NA",
        },
        {
            name: "Email",
            width: "230px",
            selector: row => row.Email,
            sortable: true,
            cell: row => row.Email,
        },
        {
            name: "Branch",
            width: "230px",
            selector: row => row.Branch.name,
            sortable: true,
            cell: row => row.Branch.name,
        },
        {
            name: "Contact Number",
            width: "150px",
            selector: row => row.ContactNumber,
            sortable: true,
            cell: row => row.ContactNumber,
        },
        {
            name: "Approval Status", 
            width: "110px",
            selector: row => row.IsApprove == true ? "Approved" : "Pending",
            sortable: true,
            cell: row => row.IsApprove == true ? "Approved" : "Pending",
            conditionalCellStyles: [
                  {
                      when: row => row.IsApprove === true,
                      style: {
                          color: 'green',
                      },
                  },
                  {
                      when: row => row.IsApprove === false,
                      style: {
                          color: 'red',
                      },
                  },
              ],
          },
        {
            name: "Actions",
            width: "240px",
            cell: (row) => (<>
                <button className="btn btn-link" title="Permission letter download" onClick={() => handleDownload(row.ApprovalLetterPdf)} ><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"></path></svg></span></button>
                <button className="btn btn-link ms-1" title="Organization map" disabled={(row.IsApprove)} hidden={(row.IsMapped && !row.IsApprove)} onClick={() => handleUserEdit(row._id)}  ><span><svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"></path><path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z"></path><path d="M16 5l3 3"></path></svg></span></button>
                <button className="btn btn-link" title="Approve" onClick={() => HandleApprove(row._id)} disabled={(row.IsApprove)} hidden={(!row.IsApprove && !row.IsMapped)} ><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.2em" width="1.2em" xmlns="http://www.w3.org/2000/svg"><path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"></path></svg></span></button>
                <button className="btn btn-link" title="Copy password" onClick={() =>getOTP(row._id)} hidden={!row.IsApprove} ><span><svg  viewBox="0 0 48 48" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48h-48z" fill="none"/><path d="M32 2h-24c-2.21 0-4 1.79-4 4v28h4v-28h24v-4zm6 8h-22c-2.21 0-4 1.79-4 4v28c0 2.21 1.79 4 4 4h22c2.21 0 4-1.79 4-4v-28c0-2.21-1.79-4-4-4zm0 32h-22v-28h22v28z"/></svg></span></button>
            </>),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const tableData = {
        columns,
        data,
    };

    const HandleApprove = async (id) => {
        ConfirmAlert("warning", 'Are you sure? Do you want to approve this participant?', 'warning', 'Yes')
            .then((result) => {
                if (result.value) {
                    getApproval(id);
                }
            });
    }

    const getApproval = async (id) => {
        const ApprovalResponse = await ApproveTempUser(id);
        if (ApprovalResponse.success === true) {
            ConfirmAlert("Approved", `OTP password for Endroll Participant <p id='OTPPassword' class="copyPassword">${ApprovalResponse.user.RandomPassword}</p>`, 'success', '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><rect width="336" height="336" x="128" y="128" fill="none" stroke-linejoin="round" stroke-width="32" rx="57" ry="57"></rect><path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M383.5 128l.5-24a56.16 56.16 0 00-56-56H112a64.19 64.19 0 00-64 64v216a56.16 56.16 0 0056 56h24"></path></svg> Copy OTP')
                .then((result) => {
                    if (result.value) {
                        copyPassword();
                        getNewEnrollUser();
                    }
                    getNewEnrollUser();
                });
        }
        else if(ApprovalResponse.response.data.message === "Email already Used"){
            InforAlert("Approve Failed!", "Student already created by this Email", 'warning', 'Ok');
        }
    }

    const getOTP = async (id) => {
        const OTPResponse = await GetOTP(id);
        if (OTPResponse.data.randomPassword === "") {
            InforAlert('Unable to retrieve it',"User already logged In", 'warning', 'OK');
        }else 
        {
            ConfirmAlert("Approved", `OTP password for Endroll Participant <p id='OTPPassword' class="copyPassword">${OTPResponse.data.randomPassword}</p>`, 'success', '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><rect width="336" height="336" x="128" y="128" fill="none" stroke-linejoin="round" stroke-width="32" rx="57" ry="57"></rect><path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M383.5 128l.5-24a56.16 56.16 0 00-56-56H112a64.19 64.19 0 00-64 64v216a56.16 56.16 0 0056 56h24"></path></svg> Copy OTP')
                .then((result) => {
                    if (result.value) {
                        copyPassword();
                    }
                });
        }
    }



    const copyPassword = () => {
        getSelection().removeAllRanges();
        var range = document.createRange();
        range.selectNodeContents(document.getElementById("OTPPassword"));
        getSelection().addRange(range);
        document.execCommand("copy");

    }

    const handleUserEdit = (id) => {
        navigate('/newenrollusersdetails', { state: { studentid: id, tempUserId: null } });
    }
    
    const BackBtn = () => {
        navigate('/home');
    }

    const getNewEnrollUser = async (orgId) => {
        let userPayload = {
            OrganizationId: orgId
        }
        var enrolluserResponse = await GetEnrollUser(userPayload);
        setData(enrolluserResponse.data);
        setLoading(false);
    }

    const addRefresh = () => {
        navigate('/home', { state: { userid: null } });
    }
    useEffect(() => {
        getNewEnrollUser();
        setTimeout(() => {
            document.getElementById('nav-dropdownSuperadmin').parentElement.classList.add('show');
            document.getElementById('nav-dropdownSuperadmin').nextSibling.classList.add('show');
        }, 300);
    }, [])


    return (
        <div className='page'>
            {loading ? <GrokLoading /> : ""}
            <NavMenu />
            <Header />
            <div className='page-wrapper'>
                <Container fluid>
                    {/* Start Page Header */}
                    <div className='page-header d-print-none'>
                        <Row className='g-2 align-items-center pb-1'>
                            <div>
                                <Breadcrumb className="custom-breadcrumb">
                                    <Breadcrumb.Item onClick={() => addRefresh()}>Home</Breadcrumb.Item>
                                    <Breadcrumb.Item active> EnrollUsers</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Col style={{ display: 'flex', alignItems: 'center' }}>
                                <Button className='nave-icon' variant='outline' size='sm' title='User'>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 256 256" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path d="M168,56a8,8,0,0,1,8-8h16V32a8,8,0,0,1,16,0V48h16a8,8,0,0,1,0,16H208V80a8,8,0,0,1-16,0V64H176A8,8,0,0,1,168,56Zm62.56,54.68a103.92,103.92,0,1,1-85.24-85.24,8,8,0,0,1-2.64,15.78A88.07,88.07,0,0,0,40,128a87.62,87.62,0,0,0,22.24,58.41A79.66,79.66,0,0,1,98.3,157.66a48,48,0,1,1,59.4,0,79.66,79.66,0,0,1,36.06,28.75A87.62,87.62,0,0,0,216,128a88.85,88.85,0,0,0-1.22-14.68,8,8,0,1,1,15.78-2.64ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Zm0,64a87.57,87.57,0,0,0,53.92-18.5,64,64,0,0,0-107.84,0A87.57,87.57,0,0,0,128,216Z"></path></svg></span>
                                </Button>
                                <h2 className="page-title"> Enroll Users</h2>
                            </Col>
                            <Col className="mb-1 me-3 col-md-auto">
                                <button className='newBtn_style' onClick={() => BackBtn()}>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                    &nbsp;&nbsp;Back
                                </button>
                            </Col>
                        </Row>
                    </div>
                    {/* End Page Header */}
                    <div className='py-4'>
                        <div className='card mb-3 mb-lg-5 '>
                            {/* Header */}
                            <div className='taablist my-2'>
                                <DataTableExtensions {...tableData}>
                                    <DataTable
                                        columns={columns}
                                        data={data}
                                        fixedHeader
                                        defaultSortField="id"
                                        defaultSortAsc={false}
                                        pagination
                                        paginationPerPage={20}
                                        noDataComponent="Please select organization type & name"
                                        paginationRowsPerPageOptions={[20, 30, 50, 100]}
                                    />
                                </DataTableExtensions>
                            </div>
                        </div>
                    </div>
                </Container>
                <Footer />
            </div>
        </div>
    )
}

export default NewEnrollUser; 